"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleUrlRedirect = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var handleUrlRedirect = function (location) {
    var redirect = query_string_1.default.parse(location.search).redirect;
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: redirect || '/dashboard' });
};
exports.handleUrlRedirect = handleUrlRedirect;
